import { createContext } from 'react';

import {
  ServiceDefinition,
  ServiceDefinitions,
} from '@totem/components/administration/services/types';

interface Context {
  loading: boolean;
  data: ServiceDefinitions;
  editingService: ServiceDefinition | null;
  modalOpen: boolean;
  onRefresh: () => void;
  onAdd: () => void;
  onEdit: (service: ServiceDefinition) => void;
  onModalClose: () => void;
  onSave: (service: ServiceDefinition) => void;
  onDelete: (id: string) => void;
}

export default createContext<Context>({
  loading: false,
  data: [],
  editingService: null,
  modalOpen: false,
  onRefresh: () => {},
  onAdd: () => {},
  onEdit: () => {},
  onModalClose: () => {},
  onSave: () => {},
  onDelete: () => {},
});
